import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const TM_MappingContext = createContext(null);

type Props = {
  children: ReactElement;
};

const TM_MappingProvider: FunctionComponent<Props> = ({ children }) => {
  const {
    data: systemAttributesData,
    isLoading: isLoadingSystemAttributes,
    error: systemAttributesError,
    isFetching: isFetchingSystemAttribute,
  } = useQuery({
    queryKey: ["tm_system_attributes"],
    staleTime: 30000,
    queryFn: async () => {
      const url = `tm/system-attributes`;
      const { data } = await Api.get(`${url}`);

      return data;
    },
  });

  const {
    data: organisationAttributrData,
    isLoading: isLoadingOrganisationAttributeData,
    error: organisationAttributeError,
    isFetching: isFetchingOrganisationAttribute,
  } = useQuery({
    queryKey: ["tm_organisation_attribute"],
    staleTime: 30000,
    queryFn: async () => {
      const url = `tm/attributes`;
      const { data } = await Api.get(`${url}`);

      return data;
    },
  });

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(`tm/attributes`, payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoadingSystemAttributes,
      systemAttributesData,
      systemAttributesError,
      isFetchingSystemAttribute,
      organisationAttributrData,
      isLoadingOrganisationAttributeData,
      organisationAttributeError,
      isFetchingOrganisationAttribute,
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [
      isLoadingSystemAttributes,
      systemAttributesData,
      systemAttributesError,
      isFetchingSystemAttribute,
      organisationAttributrData,
      isLoadingOrganisationAttributeData,
      organisationAttributeError,
      isFetchingOrganisationAttribute,
      mutateAsync,
      data,
      isPending,
      error,
    ],
  );
  return (
    <TM_MappingContext.Provider value={contextValue}>
      {children}
    </TM_MappingContext.Provider>
  );
};

export default TM_MappingProvider;
